import React, { useEffect } from 'react';
import useAdSense from '../hooks/useAdSense';

interface AdsProps {
  adClient: string;
  adSlot: string;
  adFormat?: string;
  style?: React.CSSProperties;
  className?: string;
  fullWidthResponsive?: boolean;
}

const Ads: React.FC<AdsProps> = ({
  adClient,
  adSlot,
  adFormat = 'auto',
  style = { display: 'block' },
  className = 'adsbygoogle',
  fullWidthResponsive = true,
}) => {
  useAdSense();

  useEffect(() => {
    try {
      if (!window.adsbygoogle) {
        window.adsbygoogle = [];
      }
      
      (window.adsbygoogle as any).push({});
    } catch (e) {
      console.error('AdSense error:', e);
    }
  }, []);

  return (
    <ins
      className={className}
      style={style}
      data-ad-client={adClient}
      data-ad-slot={adSlot}
      data-ad-format={adFormat}
      data-full-width-responsive={fullWidthResponsive.toString()}
    />
  );
};

export default Ads;